import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Chicago = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce  Consultant and Partner in chicago</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Transform your operations with Codezix – trusted Salesforce consulting and implementation experts in Chicago. Personalized CRM strategies that work."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting chicago Salesforce implementation chicago Codezix Salesforce services CRM solutions chicago Salesforce experts chicago Salesforce partner chicago Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Chicago</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/chicago.webp')} alt="Salesforce consulting chicago" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className="explore-heading text-left">
                                <h2>Expert Salesforce Consultant in Chicago: Your Trusted Partner for Success</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">
                                In the competitive business landscape of Chicago, finding the right tools to streamline operations and boost growth is crucial. At Codezix, we stand out as a premier Salesforce consultant in Chicago, offering businesses tailored solutions that optimize processes, enhance customer relationships, and ultimately drive long-term success.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                Our Salesforce consultants in Chicago take a personalized approach, diving deep into your business needs and aligning Salesforce solutions to your unique objectives. From streamlining sales workflows to improving customer support systems, we provide customized strategies that help businesses work more efficiently, improve collaboration, and achieve their goals faster.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                With years of experience working with businesses of all sizes, our certified team provides expert guidance through every phase of Salesforce integration, including setup, customization, and ongoing support. Whether you’re implementing Salesforce for the first time or looking to improve your current system, we ensure that Salesforce works seamlessly with your operations.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                What makes us the top Salesforce consultants in Chicago is our commitment to helping you succeed. We offer end-to-end Salesforce services, including CRM setup, custom app development, data migration, and more. Our team ensures your Salesforce environment is not only integrated with your existing systems but also optimized to deliver better data insights, improved automation, and increased productivity.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                As your trusted Salesforce consultant in Chicago, we don’t just aim to solve immediate challenges—we focus on long-term business growth. We partner with you to ensure that Salesforce becomes a strategic asset that drives operational excellence and enhances customer satisfaction.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                Choose Codezix as your Salesforce consultant in Chicago, and let us help you unlock the full potential of Salesforce to grow your business. Reach out today to begin your transformation.
                            </p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Salesforce Consulting Services in Chicago</h2>
                                <p className="prose-lg">
                                    In today’s business landscape, companies in Chicago need powerful tools to stay competitive and meet evolving customer demands. Salesforce, as a leading CRM platform, offers unparalleled solutions to drive growth, enhance customer engagement, and streamline business operations. At Codezix, we provide top-tier Salesforce consulting in Chicago, helping businesses unlock the full potential of this robust platform.                                </p>
                            </div>
                            <p className="prose-lg">
                                Our Salesforce consulting services in Chicago are designed to deliver customized solutions that align with your specific business goals. Whether you are new to Salesforce or seeking to optimize your existing Salesforce system, our team of certified consultants offers end-to-end services tailored to your needs. We begin with a deep understanding of your current processes, challenges, and objectives, ensuring that the solution we provide is fully aligned with your business requirements.
                            </p>
                            <p className="prose-lg">
                                Our services include Salesforce implementation, customization, integration, and optimization. We help businesses set up their Salesforce environment, customize features to match their workflow, and seamlessly integrate with other business systems, ensuring smooth data flow across departments. Additionally, our Salesforce consulting focuses on streamlining business operations, improving sales, and enhancing customer experiences.
                            </p>
                            <p className="prose-lg">
                                At Codezix, we are not just consultants; we are your trusted partner in digital transformation. Our approach to Salesforce consulting in Chicago goes beyond just solving immediate challenges. We work with you to develop long-term strategies that drive business success, enabling your company to make data-driven decisions, improve collaboration, and achieve scalable growth.
                            </p>
                            <p className="prose-lg">
                                If you’re looking for expert Salesforce consulting in Chicago, Codezix is here to help. Let our experienced consultants guide you through the Salesforce journey and empower your business with solutions that make a real impact. Reach out to us today and start your path to digital transformation.
                            </p>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified Salesforce consultants provide in-depth assessments of your business needs and create personalized strategies to enhance workflows and boost operational efficiency. We tackle common CRM issues such as low sales productivity and cross-department misalignment, ensuring smooth communication and driving overall performance across your entire organization. Our tailored approach optimizes Salesforce to support your business objectives effectively.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Revolutionize your operations with our expert Salesforce implementation services. Our certified professionals are skilled in setting up, customizing, and configuring Salesforce solutions and integrations that foster innovation, improve productivity, and drive sustainable business growth, perfectly aligned with your business needs and goals.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We specialize in designing custom Salesforce solutions that align with your unique business processes. Our consultants focus on solving CRM-related challenges, improving sales performance, and enhancing collaboration between teams, ensuring streamlined operations that contribute to long-term business success. Our bespoke solutions drive efficiency and meet your specific needs.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Turn your app concepts into reality with our cutting-edge Salesforce app development services. Our certified developers, based in Chicago, craft scalable and functional applications that seamlessly integrate with leading platforms. We ensure your apps are tailored to your business goals, offering innovative solutions that enhance your operations and drive growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Eliminate operational silos and maximize productivity with our advanced Salesforce integration services. We connect Salesforce with your core business systems, including ERP, CMS, DMS, and accounting software, ensuring smooth data flows across all platforms. This integration improves communication between departments, streamlines processes, and enhances operational efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Smoothly transition from legacy systems to Salesforce with our trusted migration services. Our expert team ensures secure, accurate data migration, preserving customer data integrity while minimizing disruptions. We provide a hassle-free shift to Salesforce, ensuring a seamless transition and enabling you to take full advantage of the platform’s powerful capabilities.

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our comprehensive Salesforce support services include proactive monitoring and troubleshooting to ensure smooth operations. By identifying potential issues before they impact your business, we reduce downtime and optimize workflows, keeping your organization running efficiently and free from disruptions. With our support, your Salesforce platform stays fully operational and ready for success.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Meet Our Salesforce Consulting Partner in Chicago: A Certified Team Dedicated to Your Success</h2>
                            </div>
                            <p className="prose-lg">At Codezix, we are offering expert guidance to help your business thrive. Our certified team specializes in tailoring Salesforce solutions to meet your unique needs, from seamless implementation to customizations that enhance efficiency. With years of experience across industries, we ensure your Salesforce platform aligns perfectly with your business goals, driving growth and improving operational performance. As your Salesforce consulting partner in Chicago, we are committed to your success, providing continuous support to help you achieve long-term, sustainable results. Reach out today!</p>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation chicago' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions chicago' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts chicago' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner chicago' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting chicago' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Unmatched Expertise of Salesforce Consultants in Seattle Across All Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    At Codezix, our Salesforce consultants in Seattle bring unmatched expertise in leveraging the full potential of Salesforce Clouds. From Sales Cloud to Service Cloud, Marketing Cloud, and beyond, we provide tailored solutions that cater to your business’s unique needs. Our certified consultants use their in-depth knowledge to streamline your operations, boost productivity, and enhance customer engagement. Whether you're looking to implement a specific Salesforce Cloud or integrate multiple solutions, our team ensures seamless execution and optimization. As trusted Salesforce consultants in Seattle, we deliver results that drive success and long-term growth for your business.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-chicago#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-chicago#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-chicago#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Support with Expert Salesforce Developers in Chicago</h2>
                            </div>
                            <p className="prose-lg">Our team of skilled Salesforce developers in Chicago provides innovative, industry-specific solutions that cater to diverse business needs. We work across multiple sectors, including healthcare, retail, finance, education, and manufacturing, tailoring Salesforce applications to streamline operations, enhance customer relations, and drive growth. Our developers specialize in creating customized, scalable solutions that integrate seamlessly with your existing systems, boosting productivity and providing actionable insights. Whether you're a small business or a large enterprise, our Salesforce development expertise in Chicago empowers you to overcome challenges and achieve success. Let us be your partner in transformation!</p>
                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation chicago " />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions chicago" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts chicago" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner chicago" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting chicago" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation chicagos" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="Salesforce experts chicago" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ expert developers with 300+ certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, reflecting client trust</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, fostering long-term relationships</li>
                                            <li className="wow fadeUp prose-lg">Over a decade of industry experience</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">End-to-end Support & Maintenance throughout the entire process</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support, accessible in all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house development, ensuring superior quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery, ensuring seamless execution</li>
                                            <li className="wow fadeUp prose-lg">Comprehensive testing for dependable, high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Headquartered in California, <strong>3PL Central</strong> provides an advanced warehouse management system (WMS) that streamlines operations, enhances customer satisfaction, and drives business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in the UK, <strong>24 Fit Club</strong> is a vibrant fitness community focused on promoting health and well-being. Their expert team offers top-tier fitness coaching, online classes, and forward-thinking insights to inspire clients and foster body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='CRM solutions chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a robust CRM platform providing a comprehensive enterprise solution, accessible across multiple devices. Its dynamic app marketplace strengthens marketing and sales collaboration, boosting lead generation and creating high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce experts chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They help law firms, legal departments, and public service organizations streamline case processing with centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Salesforce partner chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health assists physician practices in integrating behavioral health services such as care management, brief therapy, and psychiatric consultations. With a team of expert clinicians, industry knowledge, and cutting-edge technology, they enhance patient care and outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in Chicago, At Home Solutions provides personalized healthcare services designed to enhance the quality of life for individuals of all ages. With more than a decade of experience, they offer affordable and effective care, including companionship, tailored support, and essential medical services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Salesforce consulting chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital era, e-commerce is crucial for business success, fueling intense competition. As online shopping demand increases, businesses must implement scalable, innovative solutions to stay ahead and meet evolving consumer expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Salesforce implementation chicago' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A key highlight of 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce unveiled Agentforce, an innovative AI-powered tool designed to enhance employee productivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Understanding Salesforce MuleSoft & How Codezix Supports Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital landscape, businesses rely on a variety of applications and platforms to optimize operations and improve customer experiences. However, seamless integration can be a challenge—this is where Salesforce MuleSoft plays a vital role...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Chicago;